module.exports = __webpack_public_path__ + "img/folder.c9e7af53.png";